import { inject, provideEnvironmentInitializer } from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupById,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { provideSoftAppsModule, withLazySoftAppsModuleTranslation, withSoftAppsModuleRoutes } from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from './../i18n/de.json';
import { default as deTitles } from './../i18n/de.titles.json';
import { default as en } from './../i18n/en.json';
import { default as enTitles } from './../i18n/en.titles.json';
import { SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK } from './arbeitsbericht-statistik.shared';
import { arbeitsberichtStatistikRoutes } from './arbeitsbericht-statistik.routes';

export function provideArbeitsberichtStatistikModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'pmsArbeitsberichtStatistik',
        title: '#PMS_ARBEITSBERICHT_STATISTIK.TITLE',
        icon: 'fa-regular fa-chart-pie',
        route: '/arbeitsbericht-statistik',
        color: 'bg-primary text-white',
        permission: SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK,
        group: getModuleGroupById(8),
      },
      withSoftAppsModuleRoutes({ app: arbeitsberichtStatistikRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles, en: enTitles },
        lazy: {
          de: () => import('./../i18n/de.json'),
          en: () => import('./../i18n/en.json'),
        },
      })
    ),
  ];
}

export const arbeitsberichtStatistikProviders = [
  provideEnvironmentInitializer(async () => {
    const store = inject(Store);

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'pmsArbeitsberichtStatistik',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'pmsArbeitsberichtStatistik',
      language: 'en',
      translations: en,
    });

    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Arbeitsberichtsstatistik',
      route: '/arbeitsbericht-statistik',
      icon: 'fa-regular fa-chart-pie',
      color: 'bg-primary text-white',
      permission: SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK,
      group: getModuleGroupById(8), // Personalmanagement
    });
  }),
];
